import { Namespace, TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { joinTribe } from "@/services/api";
import { AlertTypes } from "@/utils/atoms";

import { useAlert } from "./useAlert";

const returnTribesErrorMessage = ({
  t,
  error,
}: {
  t: TFunction<Namespace, undefined, Namespace>;
  error: string;
}) => {
  // TODO: adapt cases below once backend improved it's error message
  switch (error) {
    case '400 Bad Request: ""Could not join Tribe : Already a member""':
      return t("friendsWithBenefits.joinGroup.error.alreadyInGroup");
    case '400 Bad Request: ""Could not join Tribe : Tribe has been dissolved""':
      return t("friendsWithBenefits.joinGroup.error.deletedGroup");
    case '400 Bad Request: ""Could not join Tribe : Wholesale customer not allowed to join Tribe""':
      return t("friendsWithBenefits.joinGroup.error.businessCustomer");
    case '400 Bad Request: ""Could not join Tribe : Tribe is full""':
      return t("friendsWithBenefits.joinGroup.error.tribeFull");
    case '400 Bad Request: ""Could not create Tribe : payment type not allowed""':
      return t("friendsWithBenefits.joinGroup.error.paymentMethod");
    case '400 Bad Request: ""Could not join Tribe : Tribe not found""':
    default:
      return t("friendsWithBenefits.joinGroup.error.notFound");
  }
};

export const useHandleJoinTribe = () => {
  const showAlert = useAlert();
  const { t } = useTranslation();

  const join = (tribeId: string, onSuccess?: () => void) =>
    joinTribe(tribeId)
      .then(() => {
        showAlert({
          text: t("friendsWithBenefits.joinGroup.sucess"),
          type: AlertTypes.success,
        });
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch((e) => {
        showAlert({
          text: returnTribesErrorMessage({
            t,
            error: e?.response.data,
          }),
          type: AlertTypes.error,
        });
        throw e;
      });

  return join;
};
